export enum Reason {
  Billing = "BILLING",
  PriceChange = "PRICE_CHANGE",
  MoveOut = "MOVE_OUT",
  Other = "OTHER",
}
